"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionPopover = void 0;
const React = __importStar(require("react"));
const AbstractHelpPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/AbstractHelpPopover");
const RetentionPopover = () => {
    const content = React.createElement("div", { style: { width: "380px" } },
        React.createElement("p", null, "Retention shows the percentage of users from a Cohort, who returned (sent Return events) on a specific day, week or month."));
    return React.createElement(AbstractHelpPopover_1.AbstractHelpPopover, { title: "Retention", content: content });
};
exports.RetentionPopover = RetentionPopover;
